import DetailMarketplaceProduct from './DetailMarketplaceProduct'

export default DetailMarketplaceProduct
// eslint-disable-next-line import/export
export * from './DetailMarketplaceProduct'
